module.exports = __webpack_public_path__ + "img/dy.12dc0b18.png";